const SCHEDULES = {
  drunkenDragonClosingModal: {
    startDate: "2026-04-07",
    // endDate: "2026-04-19T05:00:00"
  },
};

export const getScheduleDates = (key) => SCHEDULES[key] || null;

export const shouldPublish = (schedule) => {
  if (!schedule || !schedule.startDate) {
    return false;
  }

  const now = new Date();
  const startDate = new Date(schedule.startDate);
  if (Number.isNaN(startDate.getTime())) {
    return false;
  }

  // If no endDate, show after startDate forever
  if (!schedule.endDate) {
    return now >= startDate;
  }

  const endDate = new Date(schedule.endDate);
  if (Number.isNaN(endDate.getTime())) {
    return false;
  }

  return now >= startDate && now <= endDate;
};
